import searchAtomPair, { type SearchParams } from 'atoms/search-atom';
import type {
  TaxScenarioResult,
  TaxScenarioFacets,
  TaxScenarioAggregations,
} from './types';

export interface TaxScenarioParams extends SearchParams {
  createdBy?: string[];
  createdAt?: { start?: string; end?: string };
  updatedAt?: { start?: string; end?: string };
  effectiveDate?: { start?: string; end?: string };
}

export const createTaxScenarioSearchAtom = () =>
  searchAtomPair<
    TaxScenarioResult,
    TaxScenarioParams,
    TaxScenarioFacets,
    TaxScenarioAggregations
  >({ href: '/queries/tax_scenarios' });
